import React from "react";
import isEmpty from "lodash/isEmpty";

import DeleteIcon from "Shared/Icons/DeleteIcon";
import { formatMonetaryAmount } from "utils/formatMonetaryAmount";

import styles from "./SelectedPackageSubscriptions.module.scss";

const handleDeletePackage = (
  subscriptionId,
  selectedPackageSubscriptions,
  handleChangePackageSubscriptionSelection,
) => {
  const updatedPackages = selectedPackageSubscriptions.filter(
    (packageSubscription) => packageSubscription.id !== subscriptionId,
  );
  handleChangePackageSubscriptionSelection(updatedPackages);
};

const renderSelectedPackage = (
  packageSubscription,
  selectedPackageSubscriptions,
  handleChangePackageSubscriptionSelection,
  disableDeleteIcon,
  currencyCode,
) => {
  return (
    <div key={packageSubscription.id} className={styles.orderSummaryBox}>
      {!disableDeleteIcon && (
        <div className={styles.deleteIcon}>
          <DeleteIcon
            onClick={() =>
              handleDeletePackage(
                packageSubscription.id,
                selectedPackageSubscriptions,
                handleChangePackageSubscriptionSelection,
              )
            }
          />
        </div>
      )}
      <div className={styles.label}>
        <span className={styles.detailTitle}>Package Name:</span>
        <span>{packageSubscription.displayName}</span>
      </div>
      <div className={styles.label}>
        <span className={styles.detailTitle}>Plan Name:</span>
        <span>{packageSubscription.planName}</span>
      </div>
      <div className={styles.label}>
        <span className={styles.detailTitle}>Validity:</span>
        <span>{packageSubscription.planValidity}</span>
      </div>
      <div className={styles.mrp}>
        <span className={styles.detailTitle}>MRP:</span>
        <span>
          {formatMonetaryAmount(packageSubscription.mrp, currencyCode)}
        </span>
      </div>
    </div>
  );
};

const SelectedPackageSubscriptions = (props) => {
  const {
    selectedPackageSubscriptions,
    handleChangePackageSubscriptionSelection,
    disableDeleteIcon,
    currencyCode,
  } = props;

  return (
    <div className={styles.orderSummaryContainer}>
      <div className={styles.text}>Selected Package Subscriptions</div>
      {isEmpty(selectedPackageSubscriptions) ? (
        <p className={styles.emptyState}>No packages selected.</p>
      ) : (
        selectedPackageSubscriptions.map((packageSubscription) =>
          renderSelectedPackage(
            packageSubscription,
            selectedPackageSubscriptions,
            handleChangePackageSubscriptionSelection,
            disableDeleteIcon,
            currencyCode,
          ),
        )
      )}
    </div>
  );
};

export default SelectedPackageSubscriptions;
